import { Currency } from "../../currency/objects/currency";
import { BankAccount } from "../objects/bankAccount";
import { BankAccountListConfiguration, BankAccountListCriteria, BankAccountListFiltersCriteria } from "../objects/bankAccountLIst ";
import { ClientAccount } from "../objects/clientAccount";
import { ClientListCriteria, ClientListFiltersCriteria } from "../objects/clientAccountLIst";
import { Column } from "../objects/column";
import { IncomeStatment } from "../objects/incomeStatment";
import { IncomeStatmentListConfiguration, IncomeStatmentListCriteria, IncomeStatmentListFiltersCriteria } from "../objects/incomStatmentLIst";
import { NewspaperAccount } from "../objects/newspaperAccount";
import { NewspaperListConfiguration, NewspaperListCriteria, NewspaperListFiltersCriteria } from "../objects/newspaperAccountList";
import { PurchaseAccount } from "../objects/purchaseAccount";
import { SaleAccount } from "../objects/saleAccount";

export const ACCOUNT_SALES_MODULE = 'ACCOUNT_SALES_MODULE';
export const ACCOUNT_PURCHASES_MODULE = 'ACCOUNT_PURCHASES_MODULE';
export const ACCOUNT_CLIENT_MODULE = 'ACCOUNT_CLIENT_MODULE';
export const ACCOUNT_NEWSPAPER_MODULE = 'ACCOUNT_NEWSPAPER_MODULE';
export const BANK_ACCOUNT_MODULE = 'BANK_ACCOUNT_MODULE';

export const EMPTY_CURRENCY: Currency = {
    id: 47,
    symbol: '€',
    iso_code: 'EUR',
    international_name: 'Euro',
    usd_factor: '0.9',
    custom_currency: [],
    name: 'Euro'
};

export const EMPTY_SALE_ACCOUT: Partial<SaleAccount> = {
    product_account: "",
    product_selling_account: "",
    name: "",
    product_types: [],
    is_tva: false,
    tva_ca_percentage_1: null,
    tva_code_1: null,
    tva_percentage_1:  null,
    tva_ca_percentage_2: null,
    tva_code_2: null,
    tva_percentage_2: null
};
export const EMPTY_PURCHASE_ACCOUT: Partial<PurchaseAccount> = {
    provision_account: "",
    charge_account: "",
    name: "",
    product_types: [],
    is_tva: false,
    tva_ca_percentage_1: null,
    tva_code_1: null,
    tva_percentage_1:  null,
    tva_ca_percentage_2: null,
    tva_code_2: null,
    tva_percentage_2: null
};
export const EMPTY_CLIENT_ACCOUNT: Partial<ClientAccount> = {
    account_number: "",
    name: "",
    type: "CLIENT"
};
export const EMPTY_NEWSPAPER_ACCOUNT: Partial<NewspaperAccount> = {
    code: "",
    label: "",
    type: "PURCHASE"
};
export const EMPTY_INCOME_STATMENT: IncomeStatment = {
    account_number: "",
    name: "",
    product_types: [],
    forecast_number: "",
    is_tva: false,
    tva_ca_percentage_1: null,
    tva_code_1: null,
    tva_percentage_1: null,
    tva_ca_percentage_2: null,
    tva_code_2: null,
    tva_percentage_2: null
};

export const EMPTY_BNK_ACCOUNT: BankAccount = {
    credit_account: "",
    name: "",
    payment_code: []
};


export const DEFAULT_COLUMN: Column[] = [
    {
        label: 'invoice-account',
        field_name: 'ACCOUNT_NUMBER',
        checked: true,
        order_by: 'charge_account',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'forecast-account',
        field_name: 'FORECAST_NUMBER',
        checked: true,
        order_by: 'provision_account',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'label',
        field_name: 'LABEL',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'products-types',
        field_name: 'PRODUCTS_TYPES',
        checked: true,
        order_by: 'product_types',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const EMPTY_INCOME_STATMENT_LIST_CONFIGURATION: IncomeStatmentListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};



export const SALE_COLUMN: Column[] = [
    {
        label: 'invoice-account',
        field_name: 'ACCOUNT_NUMBER',
        checked: true,
        order_by: 'product_selling_account',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'forecast-account',
        field_name: 'FORECAST_NUMBER',
        checked: true,
        order_by: 'product_account',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'label',
        field_name: 'LABEL',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'products-types',
        field_name: 'PRODUCTS_TYPES',
        checked: true,
        order_by: 'product_types',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];
export const SALE_MCI_COLUMN: Column[] = [
    {
        label: 'invoice-account',
        field_name: 'ACCOUNT_NUMBER',
        checked: true,
        order_by: 'product_selling_account',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'forecast-account',
        field_name: 'FORECAST_NUMBER',
        checked: true,
        order_by: 'product_account',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'analytic-code',
        field_name: 'ANALYTIC_CODE',
        checked: true,
        order_by: 'analytic_code',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'label',
        field_name: 'LABEL',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'products-types',
        field_name: 'PRODUCTS_TYPES',
        checked: true,
        order_by: 'product_types',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

const domain = window.location.host.split('.')[1];
export const EMPTY_SALE_LIST_CONFIGURATION: IncomeStatmentListConfiguration = {
    columns: domain === 'tripmci' ? SALE_MCI_COLUMN : SALE_COLUMN,
    preferences: []
};



export const EMPTY_INCOME_STATMENT_FILTERS: IncomeStatmentListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};


export const EMPTY_INCOME_STATMENT_LIST_CRITERIA: IncomeStatmentListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_INCOME_STATMENT_FILTERS,
    search: '',
    client_branch: null,
    target_client__in: []
};


export const BANK_ACCOUNT_COLUMN: Column[] = [
    {
        label: 'account-number',
        field_name: 'ACCOUNT_NUMBER',
        checked: true,
        order_by: 'credit_account',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'label',
        field_name: 'LABEL',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'payment-type',
        field_name: 'PAYMENT_CODE',
        checked: true,
        order_by: 'product_types',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const EMPTY_BANK_ACCOUNT_FILTERS: BankAccountListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};


export const EMPTY_BANK_ACCOUNT_LIST_CRITERIA: BankAccountListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_BANK_ACCOUNT_FILTERS,
    search: '',
    target_client__in: [],
    client_branch: null
};

export const EMPTY_BANK_ACCOUNT_LIST_CONFIGURATION: BankAccountListConfiguration = {
    columns: BANK_ACCOUNT_COLUMN,
    preferences: []
};



export const CLIENT_COLUMN: Column[] = [
    {
        label: 'account-number',
        field_name: 'ACCOUNT_NUMBER',
        checked: true,
        order_by: 'account_number',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'label',
        field_name: 'LABEL',
        checked: true,
        order_by: 'label',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'type',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const EMPTY_CLIENT_LIST_CONFIGURATION: IncomeStatmentListConfiguration = {
    columns: CLIENT_COLUMN,
    preferences: []
};


export const EMPTY_CLIENT_FILTERS: ClientListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    type: "ALL"
};


export const EMPTY_ClIENT_LIST_CRITERIA: ClientListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_CLIENT_FILTERS,
    search: '',
    client_branch: null,
    target_client__in: []
};


export const NEWSPAPER_COLUMN: Column[] = [
    {
        label: 'newspaper-code',
        field_name: 'CODE',
        checked: true,
        order_by: 'code',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'label',
        field_name: 'LABEL',
        checked: true,
        order_by: 'label',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'newspaper-type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'type',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const EMPTY_NEWSPAPER_FILTERS: NewspaperListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};


export const EMPTY_NEWSPAPER_LIST_CRITERIA: NewspaperListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_NEWSPAPER_FILTERS,
    search: '',
    client_branch: null
};

export const EMPTY_NEWSPAPER_LIST_CONFIGURATION: NewspaperListConfiguration = {
    columns: NEWSPAPER_COLUMN,
    preferences: []
};